import { render, staticRenderFns } from "./split-payment-configuration.vue?vue&type=template&id=1a141d8a&scoped=true"
import script from "./split-payment-configuration.vue?vue&type=script&lang=js"
export * from "./split-payment-configuration.vue?vue&type=script&lang=js"
import style0 from "./split-payment-configuration.vue?vue&type=style&index=0&id=1a141d8a&prod&scoped=true&lang=css"
import style1 from "./split-payment-configuration.vue?vue&type=style&index=1&id=1a141d8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a141d8a",
  null
  
)

export default component.exports